/* eslint-disable import/prefer-default-export */
export const ImportOrderTypeEnum = {
  default: 1,
  folha_senior: 2,
};
